// extracted by css-extract-rspack-plugin
export default {"container":"Header-module__container__w6M5R7O"};